import { Tooltip as AntdTooltip } from "antd";
import type { TooltipProps as AntdTooltipProps } from "antd";

export const POPUP_CONTAINER = "popup-container";
export const POPUP_CONTAINER_SELECTOR = `.${POPUP_CONTAINER}`;

export function getClosestOrParent(selector = POPUP_CONTAINER) {
  return (node) => node.closest(selector) || node.parentElement;
}

type TooltipProps = {
  /** Use the popup fix (the popup fix uses `getPopupContainer` to parent the popup manually). Disabling this reverts to the default AntD behavior. @default true */
  popupFix?: boolean;
  /** The selector string for the popup container to parent the tooltip to. @default {@link POPUP_CONTAINER_SELECTOR} */
  popupContainerSelector?: string;
  /** Overrides our custom popup-parenting function. Default will parent to the closest ancestor that matches the `popupContainer` prop or,
   * if one is not found, will parent to the node's parent element */
  getPopupContainer?: AntdTooltipProps["getPopupContainer"];
} & AntdTooltipProps;

/**
 * Wraps AntD's Tooltip component. Uses custom tooltip popup container assignment to fix detached tooltips when scrolling.
 * See {@link TooltipProps} to customize or disable these customizations.
 */
export default function Tooltip({
  popupFix = true,
  popupContainerSelector = POPUP_CONTAINER_SELECTOR,
  getPopupContainer = getClosestOrParent(popupContainerSelector),
  children,
  ...props
}: TooltipProps) {
  return (
    <AntdTooltip {...(popupFix && { getPopupContainer })} {...props}>
      {children}
    </AntdTooltip>
  );
}
